import axios from 'axios';
import router from '../router';

const state = {    
  orders: [],
  order: null
};


const mutations = {
// orders mutations
    SET_ORDERS(state, orders) {
        state.orders = orders;
    },
    SET_ORDERDETAIL(state, order) {
        state.order = order;
    },
};

const actions = {
// orders actions
    async fetchOrders({ commit }, { search }) {
        console.log('Fetching orders with search term: ', search);
        const userToken = localStorage.getItem('userToken'); 
        if (!userToken) {
            // Redirect to login page if token is not found
            router.push({ name: 'login' });
            return;
        }

        try {
        const response = await axios.get(`https://api.datafangst.dk/api/filterorders?search=${search}&limit=200`, { headers: { Authorization: `Bearer ${userToken }` }, } );
        console.log('Ordre hentet ', response.data.orders);
        commit('SET_ORDERS', response.data.orders);
        } catch (error) {
        console.error('Error fetching orders:', error);
        throw error; // Rethrow the error to handle it in the component
        }
    },
    async fetchOrderDetail({ commit }, orderId) {
        console.log('Fetching orders with search term: ', orderId);
        const userToken = localStorage.getItem('userToken'); 
        if (!userToken) {
            // Redirect to login page if token is not found
            router.push({ name: 'login' });
            return;
        }

        try {
        const response = await axios.get(`https://api.datafangst.dk/api/filterorders/${orderId}`, { headers: { Authorization: `Bearer ${userToken }` }, } );
        console.log('Ordre hentet ', response.data.order);
        commit('SET_ORDERDETAIL', response.data.order);
        } catch (error) {
        console.error('Error fetching orders:', error);
        throw error; // Rethrow the error to handle it in the component
        }
    }
};

const getters = {
// orders getters
};
    
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};